"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ReportingProvider_1 = require("./ReportingProvider");
const ReactReportContextType_1 = require("./ReactReportContextType");
exports.ReactReportContext = react_1.default.createContext(undefined);
exports.ReportProvider = (props) => {
    const { children } = props;
    const reportingContext = react_1.default.useContext(ReportingProvider_1.ReactReportingContext);
    const [cntx, setCntx] = react_1.default.useState();
    react_1.default.useEffect(() => {
        (function () {
            return __awaiter(this, void 0, void 0, function* () {
                if (reportingContext === undefined) {
                    throw new Error("No Reporting context provided. ReportProvider must be wrapped by ReportingProvider component");
                }
                const reportContext = yield reportingContext.getReportContext(props.id);
                const cntx = new ReactReportContextType_1.ReactReportContextType({
                    componentsMiddlewares: reportingContext.componentsMiddlewares,
                    reportContext: reportContext,
                });
                setCntx(cntx);
            });
        })();
    }, []);
    if (cntx === undefined) {
        return null;
    }
    return react_1.default.createElement(exports.ReactReportContext.Provider, { value: cntx }, children);
};
//# sourceMappingURL=ReportProvider.js.map